// extracted by mini-css-extract-plugin
export default {"container":"InitialConfig_container__e9Dnm","container-top":"InitialConfig_container-top__gcf5i","button-container":"InitialConfig_button-container__A97Ji"};